export const DEFAULT_ROW_COUNT_IN_TABLES = "default_row_count_in_tables";
export const MAX_FILE_SIZE_OF_EXECUTION_MARK = "max_file_size_of_execution_mark";
export const ALLOWED_EXTENSIONS_FOR_UPLOAD = "allowed_extensions_for_upload";
export const ALLOWED_EXTENSIONS_FOR_UPLOAD_EXECUTION_MARK = "allowed_extensions_for_upload_execution_mark";
export const ADDITIONAL_ROW_COUNT_IN_TABLES = "additional_row_count_in_tables";
export const CURRENT_REGION = "current_region";
export const CURRENT_ORGANIZATION_NAME = "organization_name";
export const INCOMING_DOCUMENT_INCOMING_DATE_IS_AVAILABLE = "incoming_document_incoming_date_is_available";
export const COMPLAINT_DOCUMENT_INCOMING_DATE_IS_AVAILABLE = "complaint_document_incoming_date_is_available";
export const OUTGOING_DOCUMENT_AGREEMENT_REQUIRED = "outgoing_document_agreement_required";
// Ф.И.О. formati (JSON: {"1":"{L} {Fi} {Oi}", ...}) — backend bilan bir xil token to'plami.
export const PERSON_NAME_FORMAT = "person_name_format";
// Imzolangan hujjatlardagi sana formati (JSON: {"ru_RU":"{YYYY} год {DD} {MMMMg}", ...}).
export const DOCUMENT_REGDATE_FORMAT = "document_regdate_format";
